import { formatCurrency } from '@/services/convert'
import { updateRowStyle, updateMultipleGridRecord } from '@/services/grid'
import { AgGridVue } from 'ag-grid-vue'
import CurrencyRenderer from '@/components/DynamicComponents/Renderers/currencyRenderer'
import CustomFilter from '@/components/DynamicComponents/Renderers/customFilter'
import ToolTipRenderer from '@/components/DynamicComponents/Renderers/tooltipRenderer'

export default {
  components: {
    'ag-grid-vue': AgGridVue,
  },
  props: ['costDetails', 'columns', 'groupList', 'isArchive'],
  data() {
    return {
      data: [],
      redrawTable: false,
      loading: false,
      gridOptions: {
        suppressCellSelection: true,
        alwaysShowVerticalScroll: true,
        debounceVerticalScrollbar: true,
        alwaysShowHorizontalScroll: true,
        headerHeight: 30,
        rowHeight: 28,
        suppressRowClickSelection: true,
        rowSelection: 'multiple',
        tooltipShowDelay: 0,
        suppressContextMenu: this.isArchive,
        defaultColDef: {
          suppressMovable: true,
          singleClickEdit: false,
          sortable: true,
          menuTabs: ['filterMenuTab'],
          editable: false,
        },
      },
      columnDefs: null,
      frameworkComponents: null,
      width: '100%',
      height: '21rem',
      selectedRowKeys: [],
      selectedRows: [],
      formatCurrency: formatCurrency,
      pinnedTopRowData: [],
      groups: [],
      visible: false,
      form: {
        name: undefined,
      },
      rules: {
        name: [
          {
            required: true,
            message: 'Please Enter Estimate Group',
            trigger: 'blur',
          },
        ],
      },
      groupDetails: null,
      isRowSelectable: true,
      isValidTakeoff: false,
      checked: false,
      postSort: null,
    }
  },
  beforeMount() {
    this.loadingConfig()
    this.postSort = rowNodes => {
      const takeoffs = []
      for (let i = 0; i < rowNodes.length; i++) {
        takeoffs.push(rowNodes[i].data)
      }
      this.data = [...takeoffs]
    }
  },
  created() {
    this.$root.$on('hideLoader', this.hideLoader)
  },
  mounted() {
    this.loadingConfig()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.getWindowSize)
  },
  watch: {
    takeoffs() {
      this.getData(this.gridOptions)
    },
    costDetails() {
      this.resetRowData(this.costDetails)
    },
  },
  methods: {
    loadingConfig() {
      this.frameworkComponents = {
        customFilter: CustomFilter,
        costPriceCellRenderer: CurrencyRenderer,
        toolTipRenderer: ToolTipRenderer,
      }
      this.isRowSelectable = node => {
        if (node.data) {
          return !node.data.estimateGroupId
        }
      }
    },

    getContextMenuItems(params) {
      this.groups = this.groupList
      const record = params.node && params.node.data

      var result = [
        {
          name: 'Create New Group',
          action: () => {
            this.handleOk(record)
          },
          icon: '<i class="fa fa-plus-square-o" />',
          disabled: (record && record.estimateGroupId) || !record,
        },
        {
          name: 'Add to Group',
          icon: '<i class="fa fa-exchange" />',
          disabled:
            (record && record.estimateGroupId) ||
            this.groups.length === 0 ||
            !record,
          subMenu: this.showGroups(this.groups, record),
        },
      ]
      return result
    },

    getData(params) {
      const displayColumns = this.refreshColumns()
      params.api.setColumnDefs(displayColumns)
      params.api.sizeColumnsToFit()
      params.api.setRowData(this.costDetails)
      this.isValidTakeoff = this.costDetails.some(
        i => typeof i.isValidTakeoff !== 'undefined' && !i.isValidTakeoff,
      )
      const element = document.querySelector('#' + 'projectdetails')
      if (element) {
        this.height =
          Math.round(element.getBoundingClientRect().height) - 126 + 'px'
      }
    },

    refreshColumns() {
      const displayColumns = this.columns
      displayColumns.map(col => {
        let align = ''
        if (col.cellStyle && col.cellStyle.textAlign) {
          align = col.cellStyle.textAlign
        } else {
          align = 'left'
        }
        if (col.field !== 'action') {
          col.cellStyle = param => updateRowStyle(param, col.field, align)
        }
        if (col.headerName !== 'Action' && col.headerName !== '') {
          col.filter = 'customFilter'
          col.menuTabs = this.checked ? [] : ['filterMenuTab']
          col.sortable = !this.checked
        }
        if (col.field === 'action' || col.field === 'checkbox') {
          col.hide = this.isArchive
        }
        col.editable = false
      })
      return displayColumns
    },

    gridSizeChanged(e) {
      const element = document.querySelector('#estimateTable')
      if (element) {
        this.gridOptions.api.sizeColumnsToFit()
      }
    },

    showGroups(groups, record) {
      const subMenu = []
      groups.forEach(element => {
        subMenu.push({
          name: element.estimateGroupName,
          action: () => {
            this.createGroup(element, record)
          },
          icon: '<i class="fa fa-bars" />',
          groupDetails: element,
        })
      })
      return subMenu
    },

    handleOk(record) {
      if (record) {
        this.visible = true
        this.form.name = undefined
        this.groupDetails = record
      }
    },

    createGroup(data, record) {
      const selectedNodes = this.gridOptions.api.getSelectedNodes()
      const selectedData = selectedNodes.map(node => node.data.id)
      this.selectedRowKeys = selectedData
      this.selectedRows = selectedNodes.map(node => node.data)
      if (record) {
        let request = {}
        const ids =
          this.selectedRowKeys.length > 0 ? this.selectedRowKeys : [record.id]
        if (data) {
          request = {
            id: data.id,
            estimateGroupName: data.estimateGroupName,
            costDetailsIds: ids,
          }
          const msg = 'Please wait...'
          this.$root.$emit('popupUpdation', true, true, msg)
          this.$emit('createGroup', request)
        } else {
          this.$refs.ruleForm.validate(valid => {
            if (valid) {
              this.loading = true
              request = {
                id: 0,
                estimateGroupName: this.form.name,
                costDetailsIds: ids,
              }
              const msg = 'Please wait...'
              this.$root.$emit('popupUpdation', true, true, msg)
              this.$emit('createGroup', request)
            }
          })
        }
      }
    },

    handleCancel() {
      this.visible = false
    },

    hideLoader(flag) {
      this.loading = flag
    },

    clearSort() {
      this.gridOptions.columnApi.applyColumnState({
        defaultState: { sort: null },
      })
      this.gridOptions.api.setFilterModel(null)
    },

    resetRowData(data) {
      this.visible = false
      const itemsToUpdate = updateMultipleGridRecord(this.gridOptions, data)
      this.gridOptions.api.applyTransaction({
        update: itemsToUpdate,
      })
      this.data = [...data]
      this.gridOptions.api.redrawRows()
    },

    sortTakeoffs(value) {
      let sort = 'asc'
      let key = 'sequence'
      this.checked = value
      this.gridOptions.columnApi.applyColumnState({
        defaultState: { sort: null },
      })
      this.gridOptions.api.setFilterModel(null)
      if (value) {
        sort = 'asc'
        key = 'isValidTakeoff'
      }
      this.gridOptions.columnApi.applyColumnState({
        state: [
          {
            colId: key,
            sort: sort,
          },
        ],
        defaultState: { sort: null },
      })
      const displayColumns = this.refreshColumns()
      this.gridOptions.api.setColumnDefs(displayColumns)
      this.gridOptions.api.sizeColumnsToFit()
    },

    filterChanged() {
      this.isValidTakeoff = this.data.some(
        i => typeof i.isValidTakeoff !== 'undefined' && !i.isValidTakeoff,
      )
    },
  },
}
